module.exports = __webpack_public_path__ + "media/01.bd71aff1.wav";